// API Configuration
const API_CONFIG = {
  // Base URLs for different environments
  BASE_URLS: {
    development: process.env.REACT_APP_API_BASE_URL_DEVELOPMENT || 'http://localhost:8080',
    production: process.env.REACT_APP_API_BASE_URL_PRODUCTION || 'http://localhost:8080',
  },
  
  // Current environment - can be overridden with REACT_APP_CURRENT_ENV
  CURRENT_ENV: process.env.REACT_APP_CURRENT_ENV || (process.env.NODE_ENV === 'production' ? 'production' : 'development'),
  
  // Get the current base URL
  getBaseURL: function() {
    return this.BASE_URLS[this.CURRENT_ENV];
  },
  
  // API endpoints
  ENDPOINTS: {
    AUTH: {
      REGISTER: '/auth/register',
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      VERIFY_EMAIL: '/auth/verify',
      RESEND_VERIFICATION_CODE: '/auth/code',
      ME: '/auth/me',
      VERIFY_ONETIME: '/auth/verifyonetime'
    },
    DATA: {
      SUBMIT: '/data' // For questionnaire data submission
    },
    BILLING: {
      CREATE_SESSION: '/create-session' // For Stripe checkout session creation
    }
  },
  
  // Helper function to build full API URLs
  buildURL: function(endpoint) {
    return `${this.getBaseURL()}${endpoint}`;
  }
};

export default API_CONFIG;
